import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Container from 'react-bootstrap/Container';
import library from './Icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    helperDiv: {
        minHeight: 10,
        position: "absolute",
        top: "90%"
    }
}));

export default function SearchInput({ selectVideo, setFilteredMenu, data }) {
    const classes = useStyles();
    const [filter, setFilter] = useState("");
    const [matches, updateMatch] = useState([]);
    const [showHints, setShowHint] = useState(false);

    let copy = Object.assign([], data);

    const findValuesHelper = (obj, key, findValue, list) => {
        if (!obj) return list;
        if (obj instanceof Array) {
            for (var i in obj) {
                list = list.concat(findValuesHelper(obj[i], key, findValue, []));
            }
            return list;
        }
        if (obj[key]){
            let str = (obj[key]).toString().toUpperCase();
            if (str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(findValue)){
                list.push(obj);
            }
        }

        if ((typeof obj == "object") && (obj !== null)) {
            var children = Object.keys(obj);
            if (children.length > 0) {
                for (i = 0; i < children.length; i++) {
                    list = list.concat(findValuesHelper(obj[children[i]], key, findValue, []));
                }
            }
        }
        return list;
    }
    let maxSuggestions = 5;
    let menuItems = findValuesHelper(copy, "label", filter.toString().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), [])
    if (menuItems.length > maxSuggestions){
        menuItems.splice((maxSuggestions - 1), (menuItems.length - maxSuggestions));
    }
    let videos = menuItems.filter(x => x.video);

    return (
        <>
            <Paper component="form" onSubmit={(e) => { e.preventDefault(); setShowHint(false); setFilteredMenu(filter && filter.length > 0 ? videos : null); }} className={classes.root}>
                <InputBase
                    className={classes.input}
                    placeholder="Buscar..."
                    inputProps={{ 'aria-label': 'Buscar...' }}
                    onChange={(e) => {
                        setFilter(e.target.value);
                        if (!showHints){
                            setShowHint(true);
                        }
                    }
                    }
                    onFocus={() => setShowHint(true)}
                    value={filter}
                />
                <IconButton type="submit" className={classes.iconButton} aria-label="search">
                    <SearchIcon />
                </IconButton>
            </Paper>
            {
                showHints && filter && filter.length > 0 && videos.length > 0 ?
                    <div style={{ zIndex: 999 }} className={classes.helperDiv}>
                        <Paper component="div">
                            <Container fluid className="hints">
                                <List>
                                    {
                                        videos.map((video, index) => {
                                            return (
                                                <>
                                                    <ListItem className="selectable" key={index} onClick={() => { setShowHint(false); setFilter(video.video.title); selectVideo(video); }}>
                                                        <ListItemIcon><FontAwesomeIcon icon={video.icon} /></ListItemIcon>
                                                        <ListItemText primary={video.video.title} />
                                                    </ListItem>
                                                </>
                                            )
                                        })
                                    }
                                </List>
                            </Container>
                        </Paper>
                    </div>
                    :
                    ""
            }
        </>
    );
}